import PackageForInspection from "../../../Components/MyAccount/PackageForInspection";
import AppBar from "../../Components/AppBar";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import React from "react";
import Container from "@material-ui/core/Container";
import { useAPI } from "../../../../lib/common";
import Card from "@material-ui/core/Card";
import { CardContent } from "@material-ui/core";

export default () => {
  const [data, loading] = useAPI(
    "/sections/my-account/ajax/get_account_data.php"
  );

  if (loading) {
    return (
      <div>
        <Trans>Fetching account settings</Trans>
      </div>
    );
  }

  const { packageForInspectionSubjects } = data;
  return (
    <MobilePage>
      <AppBar />
      <PageHeader>
        <Trans>Cancel picture packages</Trans>
      </PageHeader>
      <Container>
        <Card>
          <CardContent>
            <PackageForInspection
              packageForInspectionSubjects={packageForInspectionSubjects}
            />
          </CardContent>
        </Card>
      </Container>
    </MobilePage>
  );
};
